import React, { Component } from 'react'
import './nav.css'

import ListItem from './ListItem'

class Nav extends Component {


	render() {

		const { data } = this.props;

		return (
			<div className="nav" >
				<ul>
					{data.map((item, index) => (
						<ListItem
							item={item}
							key={index}
							add={this.props.add}
							remove={this.props.remove}
						/>
					))}
				</ul>
			</div>
		)
	}
}

export default Nav


// WEBPACK FOOTER //
// ./src/components/Nav/Nav.jsx